export enum FatigueTypeformFieldRef {
  Fatigue = 's_fatigue',
}
